<nz-modal
  [(nzVisible)]="isVisible"
  nzCentered
  [nzFooter]="null"
  (nzOnCancel)="handleCancel()"
  class="insufficient-balance-modal"
>
  <ng-container *nzModalContent>
    <div class="flex flex-col items-center text-center p-6">
      <div class="mb-6">
        <img
          src="https://storage.googleapis.com/komerce/assets/icons/popup-warning.png"
          alt="warning"
          class="w-[120px] h-auto mx-auto"
        />
      </div>

      <h2 class="text-[24px] font-bold text-[#344054] mb-2">Confirm Payment</h2>
      <p class="text-[16px] text-[#667085] mb-8 leading-relaxed">
        Are you sure you want to mark this invoice as paid?
This action cannot be undone.
      </p>

      <div class="flex w-full gap-3">
        <button
          type="button"
          (click)="handleCancel()"
          class="flex-1 py-2.5 px-4 rounded-lg border border-primary text-primary font-semibold hover:bg-orange-50 transition-colors h-10"
        >
          Cancel
        </button>
        <button
          type="button"
          nz-button
          nzType="primary"
          (click)="handleConfirm()"
          class="flex-1 py-2.5 px-4 rounded-lg h-10"
        >
          Confirmation
        </button>
      </div>
    </div>
  </ng-container>
</nz-modal>
